<template>
  <div
    class="action-buttons-grid"
    :class="{ 'action-buttons-grid--dark': $vuetify.theme.dark }"
  >
    <button
      type="button"
      class="action-btn"
      :aria-label="$t('hold')"
      @click="$emit('hold')"
    >
      <v-icon size="16">fal fa-pause</v-icon>
      <span class="action-btn__label">{{ $t("hold") }}</span>
    </button>
    <button
      type="button"
      class="action-btn"
      :class="{ 'action-btn--active': noteActive }"
      :aria-label="$t('note')"
      @click="$emit('note')"
    >
        <v-icon size="16">fal fa-pencil</v-icon>
      <span class="action-btn__label">{{ $t("note") }}</span>
    </button>
    <button
      type="button"
      class="action-btn"
      :class="{ 'action-btn--active': discountActive }"
      :aria-label="$t('discount')"
      @click="$emit('discount')"
    >
        <v-icon size="16">fal fa-tag</v-icon>
      <span class="action-btn__label">{{ $t("discount") }}</span>
    </button>
    <button
      type="button"
      class="action-btn"
      :class="{ 'action-btn--active': customerActive }"
      :aria-label="$t('customer')"
      @click="$emit('customer')"
    >
        <v-icon size="16">fal fa-user</v-icon>
      <span class="action-btn__label">{{ $t("customer") }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ActionButtonsPOS",
  props: {
    noteActive: { type: Boolean, default: false },
    customerActive: { type: Boolean, default: false },
    discountActive: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* PosSmart v2: 4-column icon+label buttons */
.action-buttons-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 3px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease,
    background-color 0.15s ease;
}

.action-btn:hover {
  border-color: #5b39c9;
  color: #5b39c9;
  background: #f3f0fc;
}

.action-btn--active {
  border-color: #5b39c9;
  background: #f3f0fc;
  color: #5b39c9;
}

.action-buttons-grid--dark .action-btn {
  border-color: #2f333a;
  background: #20252d;
  color: #cbd5e1;
}

.action-buttons-grid--dark .action-btn:hover,
.action-buttons-grid--dark .action-btn--active {
  background: #2a2448;
  color: #c4b5fd;
}

.action-btn:focus-visible {
  outline: 2px solid #5b39c9;
  outline-offset: 1px;
}
</style>
